<template>
  <div
    v-if="experiments['experiment.ppUnitSold'] === 'withUnitSold' && nbUnit"
    class="w-fit flex pl-8 py-4 pr-4 border border-static-default-mid rounded-md items-center text-static-default-hi gap-4"
  >
    <IconFireFilled height="16" width="16" />
    <div class="caption-bold">
      {{ i18n(translations.unitSold) }}
    </div>
    <div class="ml-4 bg-static-default-hi rounded-sm px-4 text-body-2">
      {{ i18n(translations.total, { unit: i18n.number(nbUnit) }) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconFireFilled } from '@ds/icons/IconFireFilled'

import type { GetProductResponse } from '~/api/product-page/types'

import translations from './UnitSold.translations'

defineProps<{
  nbUnit: GetProductResponse['nbUnitSold']
}>()
const i18n = useI18n()
const experiments = useExperiments()
</script>
